export default __webpack_public_path__ + "static/media/matchmaker-arrow.de9fca82.svg";